export default () => ({
  customerAuctionDataExists: false,

  customerAttributes: {},
  customerAddressAttributes: {},

  merchantAttributes: {},
  merchantAddressAttributes: {},

  customer: {},
  customerAddress: {},
  merchant: {},
  merchantAddress: {},

  isEditing: false,
  hasAnyAds: false,
  needAvailabilityConfirmation: false,
  hasCompletedProfileData: false,
  profileType: 'PRIVATE',

  adsProducts: [],
  adsPage: 1,
  adsPages: 0,
  adsInEditing: [],
  adsInUnderReview: [],

  watchlistProducts: [],
  watchlistPage: 1,
  watchlistPages: 0,
  watchlistFilters: {},
  watchlistRefreshKey: 0,

  purchasesProducts: [],
  purchasesPage: 1,
  purchasesPages: 0,
  purchasesFilters: {},

  emailAutomations: [],
  showLowerTargetPriceForm: false,

  hasAnySearches: false,
  hasAnyActiveSearches: false,
  savedSearches: [],
  savedSearchesPage: 1,
  savedSearchesPages: 0,
  savedSearchesOrderBy: 'updated_at',
  savedSearchesOrderDir: 'desc'

})
